import { render } from "./SpeakerPage.vue?vue&type=template&id=28b524b4&scoped=true"
import script from "./SpeakerPage.vue?vue&type=script&lang=js"
export * from "./SpeakerPage.vue?vue&type=script&lang=js"

import "./SpeakerPage.vue?vue&type=style&index=0&id=28b524b4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b524b4"]])

export default __exports__